"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _1 = require(".");
const utils_1 = require("@loadsure/utils");
class InvoiceAdjustment {
    constructor(adjustmentId, invoiceId, certificateNumber, adjustmentType, adjustmentAmount, adjustmentConcept, createdDate, lastModifiedDate, status, approvedOrRejectedDate, approvedOrRejectedBy, additionalInformation) {
        this.adjustmentId = adjustmentId;
        this.invoiceId = invoiceId;
        this.certificateNumber = certificateNumber;
        this.adjustmentType = adjustmentType;
        this.adjustmentAmount = adjustmentAmount;
        this.adjustmentConcept = adjustmentConcept;
        this.createdDate = createdDate;
        this.lastModifiedDate = lastModifiedDate;
        this.status = status;
        this.approvedOrRejectedDate = approvedOrRejectedDate;
        this.approvedOrRejectedBy = approvedOrRejectedBy;
        this.additionalInformation = additionalInformation;
    }
    static fromObj(data) {
        var _a, _b;
        if (!Object.values(_1.eAdjustmentStatus).includes(data.status)) {
            throw new Error("Invalid adjustment status");
        }
        if (!data.adjustmentAmount || data.adjustmentAmount === 0) {
            throw new Error("Adjustment amount must be a non-zero value");
        }
        if (data.status !== _1.eAdjustmentStatus.PENDING_REVIEW &&
            (!data.approvedOrRejectedDate || !data.approvedOrRejectedBy)) {
            throw new Error("Approved/Rejected/Applied adjustments must include date and user information");
        }
        if (data.status === _1.eAdjustmentStatus.PENDING_REVIEW &&
            (data.approvedOrRejectedDate || data.approvedOrRejectedBy)) {
            throw new Error("Pending review adjustments should not have approval/rejection information");
        }
        return new InvoiceAdjustment((_a = data.adjustmentId) !== null && _a !== void 0 ? _a : utils_1.generateRandomStringId(8).toUpperCase(), data.invoiceId, data.certificateNumber, data.adjustmentType, data.adjustmentAmount, data.adjustmentConcept, (_b = data.createdDate) !== null && _b !== void 0 ? _b : new Date(), new Date(), data.status, data.approvedOrRejectedDate, data.approvedOrRejectedBy, data.additionalInformation);
    }
}
exports.default = InvoiceAdjustment;
//# sourceMappingURL=invoiceAdjustment.class.js.map